import { render, staticRenderFns } from "./Labelgroupdialog.vue?vue&type=template&id=4d06eb34&scoped=true"
import script from "./Labelgroupdialog.vue?vue&type=script&lang=js"
export * from "./Labelgroupdialog.vue?vue&type=script&lang=js"
import style0 from "./Labelgroupdialog.vue?vue&type=style&index=0&id=4d06eb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06eb34",
  null
  
)

export default component.exports